<template>
  <b-overlay :show="tableLoading" rounded="sm">
    <b-modal v-model="isModalVisible" id="message-modal" hide-footer class="pt-8" centered header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ $translate('activity_types') }}
        </div>
      </template>

      <div>
        <b-badge v-for="(activity_type, index) in activityTypes" :key="index" variant="success" class="role-badge m-1">
          {{ activity_type.activity_type.name }}
        </b-badge>
      </div>

    </b-modal>
    <b-modal v-model="isViewVisible" id="target-modal" hide-footer class="pt-8" centered header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ modal_title }}
        </div>
      </template>

      <div>
        <ViewTargetsModal :id="currentTargetId" @closeModal="CloseTheModal" @buttonClicked="handleButtonClick" />
      </div>

    </b-modal>
    <b-card class="inner-block health-listing">
      <b-card-header>
        <import-form :subject="$translate('targets')" v-model="importModal" @cancel="hideModal()"
          :fields="inventoryFields" :upload-record="uploadInventoryRecord" :istarget="isTarget"
          settings-key-name="TargetsUploadKey"></import-form>
        <b-row class="mt-2">

          <!-- <b-col cols="2" md="1" lg="1"
                        class="d-flex align-items-center justify-content-center"><strong>health</strong></b-col>
                    <b-col cols="10" md="11" lg="11" class="d-flex"> -->
          <b-col cols="12"
            class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button">
            <b-input type="text" :placeholder="$translate('search_filter')" v-model="query"></b-input>


            <b-button id="add-checkoff-btn" variant="blue-icon" v-b-tooltip.hover :title="$addLabel()"
              v-if="hasPermissionCreate" @click="addBudget">
              <img src="@/assets/images/icon/gradient-add.svg" />
            </b-button>

            <b-button id="import-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('import')"
              @click="openModel()" v-if="hasPermissionCreate">
              <img src="@/assets/images/icon/import.svg" />
            </b-button>
            <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('export')"
              @click="export_roster()" v-if="hasPermissionCreate">
              <img src="@/assets/images/icon/export.svg" />
            </b-button>
            <b-button id="reset-filter-btn" variant="blue-icon" @click="resetFilters" v-b-tooltip.hover
              :title="$translate('reset_filters')">
              <b-icon icon="arrow-repeat" class="fs-2" variant="dark" style=" font-size: 1.5rem"></b-icon>
            </b-button>
            <b-button variant="blue-icon" id="toggle-filter-btn" v-if="hasPermissionView" class="me-2"
              @click="toggle_filters = !toggle_filters" v-b-tooltip.hover :title="$translate('filter')">

              <img src="@/assets/images/icon/filter-f.svg" />
            </b-button>
            <b-button variant="blue-icon" id="calender-view-btn" v-if="hasPermissionView" class="me-2" v-b-tooltip.hover
              :title="$translate('calender_view')" @click="navigateToCalender">

              <img src="@/assets/images/icon/scheduling-w.svg" />
            </b-button>
            <target-actions class="activity-btn" :dropdown-actions="otherActions"
              :dropdown-title="$translate('bulk_actions')" control-class="float-right" control-size="lg" />
          </b-col>
        </b-row>
        <targets-filters v-show="toggle_filters" v-model="filters" />
      </b-card-header>
      <b-card-body class="button-off">
        <b-col class="page-block">
          <strong>
            {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
              $translate('total') }}:
            {{ pagination.total }}
          </strong>
        </b-col>
        <b-col class="overflow-auto w-100 mt-4">
          <b-table show-empty :empty-text="$translate('records_not_found')" small selectable
            @row-selected="onRowSelected" ref="selectableTable" id="order-table" responsive :items="targets"
            :fields="fields">
            <template #head(check)>
              <input id="select-order-check-box-all" type="checkbox" class="form-check-input"
                :checked="targets.length === selectedOrders.length && targets.length > 0" @change="toggleAllRow()" />
            </template>

            <template #cell(check)="{ rowSelected, index }">
              <input :id="'select-order-check-box-' + index" type="checkbox" class="form-check-input"
                :checked="rowSelected" @change="toggleRow(index, rowSelected)" />
            </template>

            <template>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <!-- <strong>{{ $translate('loading') }}</strong> -->
              </div>
            </template>
            <template #cell(name)="row">
              <!-- <b-button :id="'view-roster-btn-'+row.item.id" @click="view(row.item.id)"  class="mr-2 test-view-document-type-btn" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button> -->
              <span @click="view(row.item.id)">
                <a href="#">{{ row.item.name }}</a>
              </span>
            </template>
            <template #cell(month_year)="row">
              <div class="role-badge-container">
                {{ formatMonthYear(row.item.month_year) }}
              </div>
            </template>
            <template #cell(target)="row">


              <div class="role-badge-container">
                <span v-if="row.item.target_type === 'count'">
                  <span>
                    <!-- Use the count_type to determine the sign -->
                    {{ row.item.count_type === 1 ? '=' : (row.item.count_type === 2 ? '>' : (row.item.count_type === 3 ?
                    '<' : '' )) }} </span>
                      {{ row.item.target_no_of_activity }}

                  </span>
                  <span v-if="row.item.target_type === 'value'">
                    <span>
                      <!-- Use the count_type to determine the sign -->
                      {{ row.item.value_type === 1 ? '=' : (row.item.value_type === 2 ? '>' : (row.item.value_type === 3
                      ? '<' : '' )) }} </span>
                        {{ row.item.target_total_value }}
                    </span>
              </div>
            </template>

            <template #cell(roles)="row">
              <div class="role-badge-container">
                <b-badge v-for="(role, index) in row.item.roles" :key="index" variant="success" class="role-badge">
                  {{ role?.role?.name }}
                </b-badge>
              </div>
            </template>
            <template #cell(activity_types)="row">
              <div class="role-badge-container">
                <b-badge v-for="(activity_type, index) in row.item.activity_types.slice(0, 2)" :key="index"
                  variant="success" class="role-badge">
                  {{ activity_type?.activity_type?.name }}
                </b-badge>
                <!-- Show additional badges count if there are more than two -->
                <span v-if="row.item.activity_types.length > 2" @click="showModal(row.item.activity_types)"
                  class="badge-more">
                  +{{ row.item.activity_types.length - 2 }}...
                </span>
              </div>
              <!-- <b-modal
                            v-model="isModalVisible"
                            title="All Activity Types"
                            @hide="resetModal"
                          >
                            <div>
                              <b-badge
                                v-for="(activity_type, index) in  row.item.activity_types"
                                :key="index"
                                variant="success"
                                class="role-badge"
                              >
                                {{ activity_type.activity_type.name }}
                              </b-badge>
                            </div>
                          </b-modal> -->

            </template>
            <template #cell(officers)="row">
              <div class="role-badge-container">
                <b-badge v-for="(officer, index) in row.item.officers" :key="index" variant="success"
                  class="role-badge">
                  {{ officer?.officer?.first_name }} {{ officer?.officer?.last_name }}
                </b-badge>
              </div>
            </template>
            <template #cell(agents)="row">
              <div class="role-badge-container">
                <b-badge v-for="(agent, index) in row.item.agents" :key="index" variant="success" class="role-badge">
                  {{ agent?.agent?.first_name }} {{ agent?.agent?.last_name }}
                </b-badge>
              </div>
            </template>
            <template #cell(customer_segments)="row">
              <div class="role-badge-container">
                <b-badge v-for="(customer_segment, index) in row.item.customer_segments" :key="index" variant="success"
                  class="role-badge">
                  {{ customer_segment?.customer_segment?.name }}
                </b-badge>
              </div>
            </template>
            <template #cell(customer_group)="row">
              <div class="role-badge-container">
                <b-badge v-for="(customer_group, index) in row.item.customer_groups" :key="index" variant="success"
                  class="role-badge">
                  {{ customer_group?.customer_group?.name }}
                </b-badge>
              </div>
            </template>
            <template #cell(interaction_types)="row">
              <div class="role-badge-container">
                <b-badge v-for="(interaction_type, index) in row.item.interaction_types" :key="index" variant="success"
                  class="role-badge">
                  {{ interaction_type?.interaction_type?.name }}
                </b-badge>
              </div>
            </template>

          </b-table>
        </b-col>
        <b-row>
          <b-col>
            <b-pagination class="justify-content-center mt-4" v-model="pagination.page" :total-rows="pagination.total"
              :per-page="pagination.pageSize" aria-controls="customerTable" :prev-text="$translate('previous')"
              :next-text="$translate('next')" pills align="right"></b-pagination>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import TargetsFilters from './TargetsFilters.vue'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";
import TargetActions from "@/components/TargetActions.vue";
import dropdownIcon2 from "@/assets/images/icon/i-2.svg";
import dropdownIcon7 from "@/assets/images/icon/i-7.svg";
import ViewTargetsModal from './ViewTargetsModal.vue';


const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
  { name: "description", label: "description", required: true, type: "text" },
  { name: "month_year", label: "month_year", required: true, type: "text" },

  {
    name: "activity_type",
    label: "activity_type",
    required: true,
    type: "text",
  },
  { name: "target_type", label: "target_type", required: true, type: "text" },

  {
    name: "target_no_of_activity",
    label: "target_no_of_activity",
    required: false,
    type: "number",
  },
  {
    name: "target_total_value",
    label: "target_total_value",
    required: false,
    type: "number",
  },
  {
    name: "role",
    label: "role",
    required: false,
    type: "text",
  },
  {
    name: "officer",
    label: "officer",
    required: false,
    type: "text",
  },
  {
    name: "agent",
    label: "agent",
    required: false,
    type: "text",
  },
  {
    name: "customer_segment",
    label: "customer_segment",
    required: false,
    type: "text",
  },
  {
    name: "customer_group",
    label: "customer_group",
    required: false,
    type: "text",
  },
  {
    name: "interaction_type",
    label: "interaction_type",
    required: false,
    type: "text",
  },




];
export default {
  name: 'health-table',
  mixins: [popupMixins, permissionsMixins, importMixins],
  components: {
    TargetsFilters,
    ImportForm,
    TargetActions,
    ViewTargetsModal

  },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      selectedOrders: [],
      query: '',
      tableLoading: false,
      toggle_filters: false,
      filters: {
      },
      importModal: false,
      inventoryFields,
      isTarget: 'yes',
      activityTypes: [],
      isModalVisible: false,
      isViewVisible: false,
      currentTargetId: null,
    }
  },
  computed: {
    modal_title() {
      return this.currentTargetId ? this.$translate('targets') : this.$translate('create_targets');
    },
    fields() {
      return [
        {
          key: 'check',
          label: '', // Set the label to an empty string to hide the heading
        },
        // { key: 'id', label: this.$translate('actions') },
        { key: 'name', label: this.$translate('name') },
        { key: 'target_type', label: this.$translate('target_type') },
        { key: 'month_year', label: this.$translate('month_year') },

        { key: 'target', label: this.$translate('target') },
        { key: 'actuals', label: this.$translate('actual') },
        // { key: 'target_total_value', label: this.$translate('target_total_value') },

        { key: 'activity_types', label: this.$translate('activity_types') },
        { key: 'roles', label: this.$translate('roles') },
        { key: 'officers', label: this.$translate('officers') },
        { key: 'agents', label: this.$translate('agents') },
        { key: 'customer_segments', label: this.$translate('customer_segments') },
        { key: 'customer_group', label: this.$translate('customer_groups') },
        { key: 'interaction_types', label: this.$translate('interaction_types') },
        // { key: 'end_time', label: this.$translate('end_time') },
        // { key: 'shift', label: this.$translate('shift') },

      ]
    },
    pageCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize)
    },
    targets() {
      const targets = this.$store.state.targets.items

      return targets
    },
    pagination() {
      return this.$store.state.targets.pagination || { page: 1 }
    },
    otherActions() {
      const actions = [];

      actions.push(
        {
          action: () => this.duplicate_target(),
          icon: dropdownIcon2,
          text: this.$translate("duplicate_target"),

        },
        {
          action: () => this.view_analytics(),
          icon: dropdownIcon2,
          text: this.$translate("view_analytics"),

        },
        // {
        //   action: () => this.generate_report(),
        //   icon: dropdownIcon2,
        //   text: this.$translate("generate_report"),

        // },
        {
          action: () => this.bulk_delete(),
          icon: dropdownIcon7,
          text: this.$translate("delete"),

        },

      );



      return actions;
    },

  },

  watch: {
    targets: {
      handler: function () {
        this.tableLoading = false
      },
      deep: true,
    },
    'pagination.page': function (newPage) {
      this.changePage(newPage)
    },
    query: _.debounce(function (query) {
      this.$router.push({ query: { query } })
      this.doSearch()
    }, 200),
    filters: {
      handler: function () {

        this.doSearch(true)
      },
      deep: true,
    },
  },

  async created() {
    await Promise.all([
      this.$store.dispatch("orderType/fetchAll"),
      this.$store.dispatch("roles/fetchAll"),
      this.$store.dispatch("orders/fetchDriversNew"),
      this.$store.dispatch("customerAgents/fetchAll"),
      this.$store.dispatch("interactionType/fetchAll"),
      this.$store.dispatch('customerSegments/fetchAll'),
      this.$store.dispatch('customerGroups/fetchAll')
    ]);
  },
  mounted() {
    if (this.$route.query.query) this.query = this.$route.query.query
    this.doSearch()
    console.log('stored filter is -------',)
    if (this.$store.state.targets.filter && this.$store.state.targets.filter != null) {
      console.log('This is filter -----', this.$store.state.targets.filter.officer);

      // Check if the officer filter is not empty
      if (this.$store.state.targets.filter.officer !== "") {
        // Split the comma-separated 'value' string into an array of IDs
        let ids = value.split(',').map(id => id.trim());

        // Filter officers based on matching IDs
        let filtered_officer = this.$store.state.targets.filter.officer.filter(x => ids.includes(String(x.id)));

        // Set the filtered officer list in the filters object
        this.$set(this.filters, 'officer', filtered_officer || []);
      }
    }

  },

  methods: {
    async bulk_delete() {
      try {
        const title = this.$translate("delete_target_title");
        const message = this.$translate(`delete_target_note`);

        const result = await this.confirmMessage(title, message);
        console.log("result", result);
        if (!result) return false; //throw new Error("");

        this.tableLoading = true;
        await this.$store.dispatch("targets/bulkDelete", {
          targets: this.selectedOrders,
        });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_target_delete"),
          "success"
        );

        await this.doSearch();
      } catch (err) {
        console.error(err);
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_target_delete_error"),
          "danger"
        );
      } finally {
        this.clearSelected();
        this.doSearch(true);
        this.tableLoading = false;
      }
    },
    generate_report() {

    },
    view_analytics() {
      this.$router.push({ name: 'ViewAnalytics' });
    },
    navigateToCalender() {
      this.$router.push({ name: 'viewTargetCalender' });
    },
    async duplicate_target() {
      try {


        this.tableLoading = true;
        await this.$store.dispatch("targets/duplicate", {
          targets: this.selectedOrders,
        });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_target_duplicate"),
          "success"
        );

        await this.doSearch();
      } catch (err) {
        console.error(err);
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_target_duplicate_error"),
          "danger"
        );
      } finally {
        this.clearSelected();
        this.doSearch(true);
        this.tableLoading = false;
      }

    },
    clearSelected() {
      this.$refs.selectableTable && this.$refs.selectableTable.clearSelected();
    },
    onRowSelected(items) {
      this.selectedOrders = items;
    },
    toggleRow(index, rowSelected) {
      // Rows are indexed from 0, so the third row is index 2
      if (rowSelected) this.$refs.selectableTable.unselectRow(index);
      else this.$refs.selectableTable.selectRow(index);
    },

    toggleAllRow() {
      if (this.targets.length === this.selectedOrders.length)
        this.$refs.selectableTable.clearSelected();
      else this.$refs.selectableTable.selectAllRows();
    },

    changePage(page) {
      this.$router.push({ query: { page } })
      this.doSearch()
    },
    resetFilters() {
      this.setDefaultDateRange();
      this.doSearch()
    },
    async doSearch() {
      let type = "";
      if (this.filters.type && this.filters.type.length > 0 && Array.isArray(this.filters.type)) {
        type = this.filters.type.map((i) => i.id).join(",");
      }

      let role = "";
      if (this.filters.role && this.filters.role.length > 0 && Array.isArray(this.filters.role)) {
        role = this.filters.role.map((i) => i.id).join(",");
      }

      let officer = "";
      if (this.filters.officer && this.filters.officer.length > 0 && Array.isArray(this.filters.officer)) {
        officer = this.filters.officer.map((i) => i.id).join(",");
      }

      let agent = "";
      if (this.filters.agent && this.filters.agent.length > 0 && Array.isArray(this.filters.agent)) {
        agent = this.filters.agent.map((i) => i.id).join(",");
      }
      let customer_segment = "";
      if (this.filters.customer_segment && this.filters.customer_segment.length > 0 && Array.isArray(this.filters.customer_segment)) {
        customer_segment = this.filters.customer_segment.map((i) => i.id).join(",");
      }

      let interaction_type = "";
      if (this.filters.interaction_type && this.filters.interaction_type.length > 0 && Array.isArray(this.filters.interaction_type)) {
        interaction_type = this.filters.interaction_type.map((i) => i.id).join(",");
      }

      let customer_group = "";
      if (this.filters.customer_group && this.filters.customer_group.length > 0 && Array.isArray(this.filters.customer_group)) {
        customer_group = this.filters.customer_group.map((i) => i.id).join(",");
      }


      try {
        this.$store.commit('targets/updateFilter', {
          query: this.query,
          filters: { ...this.filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
        });
        this.tableLoading = true
        const {
          pagination: { page },
          query,
          filters
        } = this
        await this.$store.dispatch('targets/fetch', {
          query,
          page,
          filters: { ...filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
        })
      } catch (error) {
        console.error('loading error', error)
      }
    },
    view(index) {
      // const path = `${this.$route.path}/${index}`
      // console.log('path---',path);
      // this.$router.push({ path })
      this.currentTargetId = index;
      this.isViewVisible = true;
    },

    truncate(text, length) {
      return _.truncate(text, { length: length })
    },
    handleButtonClick() {
      this.doSearch();
      this.isViewVisible = false;

    },
    CloseTheModal() {
      this.currentTargetId = 0;
      this.isViewVisible = false;
    },
    addBudget() {
      this.currentTargetId = 0;
      this.isViewVisible = true;
      // const id = 0
      // this.$router.push({ params: { id }, name: 'viewTarget' })
    },
    async uploadInventoryRecord(
      dataRecord,
      statusRecord,
      // { check, message, field },
      statuses,
      // setLoading
    ) {


      try {
        let {
          month_year,
          activity_type,
          role,
          officer,
          agent,
          customer_segment,
          customer_group,
          interaction_type,
          target_total_value,
          target_no_of_activity,
          name,
          target_type,
          description

        } = dataRecord;


        month_year = month_year.trim();
        activity_type = activity_type.trim();
        role = role.trim();
        officer = officer.trim();
        agent = agent.trim();
        customer_segment = customer_segment.trim();
        customer_group = customer_group.trim();
        interaction_type = interaction_type.trim();
        target_total_value = target_total_value.trim();
        target_no_of_activity = target_no_of_activity.trim();
        name = name.trim();
        target_type = target_type.trim();
        description = description.trim();
        const param = {
          month_year,
          activity_type,
          role,
          officer,
          agent,
          customer_segment,
          customer_group,
          interaction_type,
          target_total_value,
          target_no_of_activity,
          name,
          target_type,
          description
        };
        console.log({ param });

        const res = await this.$store.dispatch("targets/upload", param);
        this.tableLoading = true;
        this.doSearch();
        this.tableLoading = false;
        // console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        // console.error("err", err);
        // statusRecord.error_list =
        //   typeof err.message == "string"
        //     ? [["error", [err.message]]]
        //     : Object.entries(err.message);
        // statusRecord.status = statuses.ERROR;
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        // setLoading(false);
      }
    },
    openModel() {

      this.importModal = true;
    },
    async export_roster() {

      this.tableLoading = true
      let filter_target = this.$store.state.targets.filter;
      let query_target = this.$store.state.targets.query;

      console.log('query-filter', filter_target);
      await this.$store.dispatch('targets/exportExcelData', {

        query_target,
        filter_target
      })
      this.tableLoading = false
    },
    setDefaultDateRange() {
      const currentDate = new Date();
      const currentDay = currentDate.getDay();
      const diffToSunday = currentDay === 0 ? 0 : 7 - currentDay;

      // Calculate the start date (two Sundays ago)
      const startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - currentDay + diffToSunday - 7);

      // Calculate the end date (next Saturday)
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 13);

      // Format dates to YYYY-MM-DD for the date input fields
      const formatDate = (date) => {
        return date.toISOString().split('T')[0];
      };

      this.filters.start_date = formatDate(startDate);
      this.filters.end_date = formatDate(endDate);
      const defaultStartTime = '10:00'; // Default start time
      const defaultEndTime = '19:00'; // Default end time
      this.filters.filter_date = formatDate(currentDate); // Set current date as the filter date
      this.filters.start_time = defaultStartTime;
      this.filters.end_time = defaultEndTime;
    },

    showModal(activityTypes) {
      this.activityTypes = activityTypes; // Set the activity types to display in the modal
      this.isModalVisible = true; // Show the modal
    },
    resetModal() {
      this.activityTypes = []; // Reset activity types when modal is closed
    },
    formatMonthYear(monthYearString) {
      const [year, month] = monthYearString.split('-'); // Split the string into year and month
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]; // Array of month names
      const monthIndex = parseInt(month) - 1; // Convert month to index (0-11)
      return `${monthNames[monthIndex]}-${year}`; // Return formatted string
    },
  },

}
</script>
<style scoped>
.role-badge-container {
  display: flex;
  flex-wrap: wrap;
  /* Allow wrapping to the next line */
  gap: 8px;
  /* Adjust space between the badges */
}

.role-badge {
  flex-basis: calc(25% - 8px);
  /* Each badge takes 25% width, minus the gap */
  text-align: center;
  /* Center align text within each badge */
  white-space: nowrap;
  /* Prevent text from wrapping inside badge */
}
</style>
